<template>
  <router-view v-on="$listeners" ref="routerView"></router-view>
</template>
<script>
export default {
  name: 'RouteWrapper',
};
</script>
